<template>
    <div :class="{ 'flex justify-end': justifyEnd }">
        <input
            :name="name"
            :size="size"
            :data-precision="isDecimal ? 2 : 0"
            :data-originalvalue="value"
            class="is-currency form-input text-right"
            :class="addClasses"
            ref="input"
            :value="value"
            @input="updateValue($event.target.value)"
            @focus="selectAll"
            @blur="formatValue">
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                default: ''
            },

            size: {
                type: Number,
                default: 10
            },

            value: {
                type: [Number, String],
                default: 0
            },

            addClasses: {
                type: String,
                required: false
            },

            justifyEnd: {
                type: Boolean,
                default: false
            },

            isDecimal: {
                type: Boolean,
                default: false
            }
        },

        mounted: function () {
            this.formatValue();
        },

        methods: {
            updateValue: function (value) {
                if (this.isDecimal) {
                    var result = value;
                } else {
                    result = this.formatCurrency(this.prepCurrency(value));
                }
                
                this.$refs.input.value = result
                
                this.$emit('input', result)
            },

            formatValue: function () {
                let value = this.prepCurrency(this.$refs.input.value);

                this.$refs.input.value = this.formatCurrency(value, this.$refs.input.dataset.precision);
            },

            selectAll: function (event) {
                setTimeout(function () {
                    event.target.select()
                }, 0)
            }
        }
    }
</script>